import {Attribute} from '../../components/ObjectAttribute';
import {Json} from '../../components/JsonObjectCard';
import searchUomsRequest from "./requests/searchUomsRequest";
import getUomRequest from "./requests/getUomRequest";
import createUomRequest from "./requests/createUomRequest";
import updateUomRequest from "./requests/updateUomRequest";
import deleteUomRequest from "./requests/deleteUomRequest";
import {RequestDefinitionData} from "../../components/RequestDefinition";

const uomsEndpoints: RequestDefinitionData[] = [
    searchUomsRequest,
    getUomRequest,
    createUomRequest,
    updateUomRequest,
    deleteUomRequest,
];

export const uomsHeader = {
    title: 'Unit of Measure',
    description: 'This is an object representing a Fishbowl unit of measure (UOM).',
    linkName: 'Unit of Measure',
    link: 'https://help.fishbowlinventory.com/advanced/s/article/Unit-of-Measure',
    endpoints: uomsEndpoints,
};

export const jsonObject: Json = {
    title: 'THE UOM OBJECT',
    json: {
        "id": 1,
        "name": "Each",
        "abbreviation": "ea",
        "description": "A single item.",
        "type": "Count",
        "active": true,
        "integral": true,
        "readOnly": true,
        "conversions": [
            {
                "id": 32,
                "description": "1 Pair = 2.0 Each",
                "targetUom": {
                    "id": 18,
                    "name": "Pair",
                    "abbreviation": "pr"
                },
                "divisor": "2",
                "multiplier": "1"
            }
        ]
    },
};

export const uomAttributes: Attribute[] = [
    {
        name: 'id',
        type: 'integer',
        description: 'The UOM\'s unique identification number.'
    }, {
        name: 'name',
        type: 'string',
        description: 'The UOM name.',
    },
    {
        name: 'abbreviation',
        type: 'string',
        description: 'The UOM abbreviation.',
    },
    {
        name: 'description',
        type: 'string',
        description: 'The UOM description.',
    },
    {
        name: 'type',
        type: 'string: \'Area\' | \'Count\' | \'Length\' | \'Time\' | \'Volume\' | \'Weight\'',
        description: 'The basic type of the UOM.',
    },
    {
        name: 'active',
        type: 'boolean',
        description: 'The active status of the UOM.',
    },
    {
        name: 'integral',
        type: 'boolean',
        description: 'Indicates if the quantity must be a whole number.',
    },
    {
        name: 'readOnly',
        type: 'boolean',
        description: 'Indicates if the UOM is read-only.',
    },
    {
        name: 'conversions',
        type: 'list',
        description: 'A list of the UOM conversions.',
        children: [
            {
                name: 'id',
                type: 'integer',
                description: 'The conversion\'s unique identification number.',
            },
            {
                name: 'description',
                type: 'string',
                description: 'The conversion description.',
            },
            {
                name: 'targetUom',
                type: 'reference object',
                description: 'The resulting UOM of the conversion.',
                children: [
                    {
                        name: 'id',
                        type: 'integer',
                        description: 'The unique identification number.',
                    },
                    {
                        name: 'name',
                        type: 'string',
                        description: 'The name of the object.',
                    },
                    {
                        name: 'abbreviation',
                        type: 'string',
                        description: 'The abbreviated name.',
                    },
                ]
            },
            {
                name: 'divisor',
                type: 'quantity',
                description: 'Divide the quantity by the divisor to convert to the target UOM.',
            },
            {
                name: 'multiplier',
                type: 'quantity',
                description: 'Multiply the quantity by the multiplier to convert to the target UOM.',
            },
        ]
    }
];
